import 'angular:locale/data:th';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "th";
